/**
 * Incoming Message Validation Hook
 * Validates incoming messages from external sources
 * Checks for required fields: messageId, author, text, timestamp
 */
import { type IPipelineContext, type HookResult } from 'edge-stream-js';
import { type HookMetadata } from '../HookMetadata';

export class ValidationHook {
  name = 'IncomingValidationHook';
  priority = 20;

  metadata?: HookMetadata = {
    name: 'IncomingValidationHook',
    description: 'Validates incoming messages from external sources. Checks for required fields: messageId, author, text, timestamp',
    version: '1.0.0',
    author: 'EdgeStream',
    tags: ['validation', 'incoming', 'security'],
    modifiesData: false,
    impactLevel: 'critical',
  };

  async execute(context: IPipelineContext): Promise<HookResult> {
    const envelope = context.envelope as any;
    const messageId = envelope.meta.id;
    const body = envelope.body as any;
    const messageData = body?.data?.data || {};

    console.log(`[IncomingValidationHook] 🔍 Validating incoming message: ${messageId}`);

    // Validate required fields for incoming messages
    const errors: string[] = [];

    if (!messageData.messageId) {
      errors.push('Missing messageId');
    }
    if (!messageData.author) {
      errors.push('Missing author');
    }
    if (!messageData.text) {
      errors.push('Missing text');
    }
    if (!messageData.timestamp) {
      errors.push('Missing timestamp');
    }

    if (errors.length > 0) {
      console.warn(`[IncomingValidationHook] ⚠️ Validation failed: ${errors.join(', ')}`);
      return {
        continue: false,
        error: `Incoming validation failed: ${errors.join(', ')}`,
      };
    }

    console.log(`[IncomingValidationHook] ✅ Incoming message validated: ${messageId}`);
    return { continue: true };
  }
}
